import { FaPhoneAlt } from 'react-icons/fa'
import { Button } from '@outbound-ai/ursa'

interface IProps {
  isDialCallDisabled: boolean
  setShowStandardCall: (startCall: boolean) => void
}

export const StartManualCallButton = ({ isDialCallDisabled, setShowStandardCall }: IProps) => {
  return (
    <Button
      variant="info"
      size="normal"
      radius="rounded"
      width="181px"
      disabled={isDialCallDisabled}
      onClick={() => setShowStandardCall(true)}
    >
      <FaPhoneAlt />
      Start Manual Call
    </Button>
  )
}
